import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { PipeModule } from '@shared/pipe/pipe.module';
import { YoutubeDialogComponent } from '@client/shared/components/youtube-dialog/youtube-dialog.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DirectivesModule } from '@shared/directives/directives.module';
import { YoutubeVideosEnum } from 'taxtank-core';

@Component({
  selector: 'app-youtube-preview',
  imports: [PipeModule, MatDialogModule, DirectivesModule],
  templateUrl: './youtube-preview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './youtube-preview.component.scss'
})
/**
 * Component to display the YouTube video thumbnail as a preview image, and only load and show the actual YouTube iframe
 * in a popup dialog after the user clicks on the thumbnail.
 */
export class YoutubePreviewComponent {
  private dialog = inject(MatDialog);

  @Input() thumbnail: string;
  @Input() videoId: YoutubeVideosEnum;
  @Input() height?: string;
  @Input() top = '50%';
  youtubeVideosReverseMap = Object.fromEntries(
    Object.entries(YoutubeVideosEnum).map(([k, v]) => [v, k])
  );
  prefix = 'assets/img/youtube/';

  

  openYoutubeDialog(): void {
    this.dialog.open(YoutubeDialogComponent, {
      panelClass: 'dialog-medium',
      data: {
        videoId: this.videoId,
      },
    });
  }
}
